import {
  arrayRemove,
  collection,
  doc,
  getDoc,
  getDocs,
  increment,
  updateDoc,
  addDoc,
} from "@firebase/firestore";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { auth, db } from "../../firebase";
import placeOr from "../../assets/place-or.png";
import noto from "../../assets/noto.png";
import { Link } from "react-router-dom";
import { onAuthStateChanged } from "@firebase/auth";

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Elements } from "@stripe/react-stripe-js";
import PaymentGateway from "../payment/PaymentGateway";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const CartCheckout = ({ subTypesModal, setSubTypesModal }) => {
  const [user, setUser] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      firebaseUser ? setUser(firebaseUser) : setUser(null);
    });
    return () => unsubscribe();
  }, []);

  const [userCartItems, setUserCartItems] = useState([]);
  const [userData, setUserData] = useState(null);
  const [subscriptions, setSubscriptions] = useState([]);
  const [userSubs, setUserSubs] = useState([]);
  const [nonSubServices, setNonSubServices] = useState([]);
  const [subscribedServices, setSubscribedServices] = useState([]);
  const [couponsList, setCouponsList] = useState([]);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [tipAmount, setTipAmount] = useState(0);
  const [finalTipAmount, setFinalTipAmount] = useState(0);
  const [loadingCart, setLoadingCart] = useState(false);
  const [dateTime, setDateTime] = useState(new Date().getTime());
  const [description, setDescription] = useState("");
  const [paymentMode, setPaymentMode] = useState("COD");

  const [paymentResultModal, setPaymentResultModal] = useState(false);
  const handleOpenPaymentResultModal = () => setPaymentResultModal(true);
  const handleClosePaymentResultModal = () => {
    setPaymentDetails(null);
    setProcessingPayment(false);
    setPaymentResultModal(false);
  };

  const handleOpenSubTypesModal = () => setSubTypesModal(true);
  const handleCloseSubTypesModal = () => {
    setTipAmount(0);
    setAppliedCoupon(null);
    setSubTypesModal(false);
  };

  useEffect(() => {
    if (tipAmount) {
      setFinalTipAmount(tipAmount * userCartItems.length);
    }
  }, [tipAmount, userCartItems.length]);

  const [congratsModal, setCongratsModal] = useState(false);
  const handleOpenCongratsModal = () => setCongratsModal(true);
  const handleCloseCongratsModal = () => setCongratsModal(false);

  const [subStatusModal, setSubStatusModal] = useState(false);
  const handleOpenSubStatusModal = () => setSubStatusModal(true);
  const handleCloseSubStatusModal = () => setSubStatusModal(false);

  const [dateTimeModal, setDateTimeModal] = useState(false);
  const handleOpenDateTimeModal = () => setDateTimeModal(true);
  const handleCloseDateTimeModal = () => setDateTimeModal(false);

  const [locationModal, setLocationModal] = useState(false);
  const handleOpenLocationModal = () => setLocationModal(true);
  const handleCloseLocationModal = () => setLocationModal(false);

  const [paymentModal, setPaymentModal] = useState(false);
  const handleOpenPaymentModal = () => setPaymentModal(true);
  const handleClosePaymentModal = () => setPaymentModal(false);

  const [thankYouModal, setThankYouModal] = useState(false);
  const handleOpenThankYouModal = () => setThankYouModal(true);
  const handleCloseThankYouModal = () => setThankYouModal(false);

  const [congratsMessage, setCongratsMessage] = useState({
    status: false,
    message: "",
  });

  useEffect(() => {
    if (congratsMessage.message) {
      handleOpenCongratsModal();
      handleCloseCouponModal();
    }
  }, [congratsMessage]);

  useEffect(() => {
    if (user && user?.uid && subTypesModal) {
      fetchCartItems();
      fetchAllSubscriptions();
    }
  }, [user, subTypesModal]);

  const [couponModal, setCouponModal] = useState(false);
  const handleOpenCouponModal = () => {
    fetchAllCoupons();
    setCouponModal(true);
  };
  const handleCloseCouponModal = () => setCouponModal(false);

  const fetchAllSubscriptions = async () => {
    const querySnapshot = await getDocs(collection(db, "subscriptions"));
    const mSubscriptions = [];
    querySnapshot.forEach((doc) => {
      mSubscriptions.push({ id: doc.id, ...doc.data() });
    });
    setSubscriptions(mSubscriptions);
  };

  const fetchAllCoupons = async () => {
    const couponsRef = collection(db, "coupons");
    const querySnapshot = await getDocs(couponsRef);
    const mCouponsList = [];
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      mCouponsList.push({ id: doc.id, ...doc.data() });
    });
    setCouponsList(mCouponsList);
  };

  const fetchCartItems = async () => {
    if (!user || !user.uid) {
      console.log();
      return;
    }
    const userCartRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userCartRef);
    if (
      userSnap.exists() &&
      userSnap.data().cart &&
      userSnap.data().cart.length
    ) {
      setUserCartItems(userSnap.data().cart);
      setUserData(userSnap.data());
    } else {
      setUserCartItems([]);
    }

    if (
      userSnap.exists() &&
      userSnap.data().subscriptions &&
      userSnap.data().subscriptions.length
    ) {
      setUserSubs(userSnap.data().subscriptions);
    } else {
      setUserSubs([]);
    }
  };

  const deleteCartItem = async (mCartItem) => {
    // let tempCartItems = [...userCartItems];
    // tempCartItems = tempCartItems.filter(
    //   (mCart) => mCartItem.sub_type_id !== mCart.sub_type_id
    // );

    setLoadingCart(true);
    // push this to db
    const userCartRef = doc(db, "users", user.uid);
    try {
      await updateDoc(userCartRef, { cart: arrayRemove(mCartItem) });
      await fetchCartItems();
    } catch (error) {
      alert("Something went wrong! Please try again!");
    } finally {
      setLoadingCart(false);
    }
  };

  const checkCouponValidity = async (mCoupon) => {
    // decrement quantity after success apply

    // check if date is valid
    if (new Date() > new Date(mCoupon.validity)) {
      return setCongratsMessage({
        status: false,
        message: `This coupon is expired`,
      });
    }
    if (mCoupon.type === "percentage") {
      // order amount > min_order_amount
      if (totalPrice > mCoupon.min_order) {
        // TODO: replace discount with value from db
        const percentDiscount = 5;
        let benefit = totalPrice * percentDiscount * 0.01;
        // total benefit < max_benefit
        if (benefit > mCoupon.max_benefit) {
          benefit = mCoupon.max_benefit;
        }
        const couponDoc = doc(db, "coupons", mCoupon.id);
        try {
          await updateDoc(couponDoc, { quantity: increment(-1) });
          setCongratsMessage({
            status: true,
            message: `Congrats! You saved $ ${benefit}`,
          });
          setAppliedCoupon({
            status: true,
            coupon: mCoupon,
            benefit,
          });
        } catch (error) {
          alert("Error updating coupon status! Try again!");
        }
      } else {
        setCongratsMessage({
          status: false,
          message: `Minimum order amount is $ ${mCoupon.min_order}`,
        });
      }
    }
  };

  useEffect(() => {
    if (userCartItems.length) {
      checkSubscriptionStatus();
    }
    // else if (userCartItems.length === 1) {
    //   let isSubscriptionAvailable = userSubs.filter((userSub) => {
    //     return userSub.sub_type_id === userCartItems[0].sub_type_id;
    //   });
    //   // if length >= 1 : subs is available
    //   // else 0: subs is not available
    //   if (isSubscriptionAvailable.length) {
    //     console.log("if length >= 1 : subs is available");
    //     setNonSubServices([]);
    //   } else {
    //     console.log("else 0: subs is not available");
    //     setNonSubServices([userCartItems[0]]);
    //   }
    // }
  }, [userCartItems, userSubs]);

  const [totalPrice, setTotalPrice] = useState(0);
  const [totalVat, setTotalVat] = useState(0);
  const [payableAmount, setPayableAmount] = useState(0);

  const checkSubscriptionStatus = async () => {
    let nonSubItems = userCartItems.filter((cartItem) => {
      let ar = userSubs.filter((userSub) => {
        return userSub.sub_type_id === cartItem.sub_type_id;
      });
      return ar.length <= 0;
    });

    let cartArr = [...userCartItems];
    let subscribedSer = [];
    for (let i = 0; i < userSubs.length; i++) {
      const element = userSubs[i];
      for (let j = 0; j < cartArr.length; j++) {
        const cartObj = cartArr[j];
        if (cartObj.sub_type_id === element.sub_type_id) {
          subscribedSer.push(cartObj);
        }
      }
    }
    console.log("QTYYYYYY:", subscribedSer);
    setSubscribedServices(subscribedSer);

    console.log("NON_SUB_ITEMS:", nonSubItems);
    let mTotalPrice = 0;
    let mTotalVat = 0;
    nonSubItems.forEach((nonSub) => {
      mTotalPrice += nonSub.price;
      mTotalVat += nonSub.vat;
    });
    setTotalPrice(mTotalPrice);
    setTotalVat(mTotalVat);

    setNonSubServices(nonSubItems);
  };

  const emptyTheCart = async () => {
    const cartRef = doc(db, "users", user.uid);

    // Remove the 'capital' field from the document
    await updateDoc(cartRef, {
      cart: [],
    });
  };

  const placeFinalOrder = async () => {
    try {
      // TODO: decrease the count of subscription in user schema

      userCartItems.map(async (cartItem) => {
        const orderObj = {
          address: userData && userData.address ? userData.address : "",
          coordinates: "",
          date_accepted: new Date().getTime(),
          date_assigned: new Date().getTime(),
          date_booked: new Date().getTime(),
          date_completed: new Date().getTime(),
          date_service: dateTime,
          description,
          employee_id: "",
          employee_amount: "",
          employee_number: "",
          employee_name: "",
          employee_review: "",
          employee_token: "",
          image1: "",
          image2: "",
          image3: "",
          is_completed: false,
          is_cancelled: false,
          order_status: "placed",
          payment_method: paymentMode,
          sub_type_id: cartItem.sub_type_id,
          service_id: cartItem.service_id,
          sub_service_id: cartItem.sub_service_id,
          tip: tipAmount,
          total_amount: cartItem.price + cartItem.price * 0.05 + tipAmount,
          vat: cartItem.price * 0.05,
          price: cartItem.price,
          // TODO: discount & coupon code
          discount:
            appliedCoupon && appliedCoupon.status ? appliedCoupon?.benefit : 0,
          coupon_code:
            appliedCoupon && appliedCoupon.status
              ? appliedCoupon?.coupon?.code
              : "",
          name: cartItem?.name,
          image: cartItem?.image,
          user_id: user && user.uid ? user.uid : "",
          user_name: "",
          user_number: "",
          user_email: "",
          user_review: "",
          user_sub_id: "",
          user_token: "",
        };

        const orderDocRef = await addDoc(collection(db, "orders"), orderObj);
        console.log("Order Doc written with ID: ", orderDocRef.id);
        // TODO: update quantity in DB
      });

      // reduce the qty of subscribed services
      let mSubs = [...userSubs];
      let newMSubs = [];
      let mSubsServices = [...subscribedServices];
      console.log("QTY B4: ", mSubs);
      console.log("QTY B4: ", nonSubServices);
      if (mSubs && mSubs.length) {
        for (let i = 0; i < mSubsServices.length; i++) {
          const element = mSubsServices[i];
          for (let j = 0; j < mSubs.length; j++) {
            let userSub = mSubs[j];
            if (userSub.sub_type_id === element.sub_type_id) {
              let qty = userSub.quantity - 1;
              userSub = { ...userSub, quantity: qty };
            }
            newMSubs.push(userSub);
          }
        }
      }

      // determine new used coupons
      let userCoupons =
        userData.user_coupons && userData.user_coupons.length
          ? userData.user_coupons
          : [];

      if (appliedCoupon?.status) {
        let foundIndex = userCoupons.findIndex(
          (x) => x.id === appliedCoupon?.coupon?.id
        );
        if (foundIndex === -1) {
          // this coupon is getting used for first time
          userCoupons.push({
            name: appliedCoupon?.coupon?.code,
            count: 1,
            id: appliedCoupon?.coupon?.id,
          });
        } else {
          // reduce the count by 1
          userCoupons[foundIndex].count--;
        }
      }

      await updateDoc(doc(db, "users", user.uid), {
        subscriptions: newMSubs,
        user_coupons: userCoupons,
      });
      console.log("QTY AFTER: ", newMSubs);

      emptyTheCart();
      handleOpenThankYouModal();
      handleCloseDateTimeModal();
      handleCloseLocationModal();
      handleClosePaymentModal();
      handleCloseSubStatusModal();
      handleCloseSubTypesModal();
    } catch (e) {
      alert("error creating orders");
      console.log("ERROR ORDER:", e);
    }
  };

  // address change
  const [addressToChange, setAddressToChange] = useState("");
  const [changeAddressActive, setChangeAddressActive] = useState(false);
  const toggleAddressChange = () => setChangeAddressActive((prev) => !prev);

  const updateTheAddress = async () => {
    const userRef = doc(db, "users", user.uid);
    // Set the "capital" field of the city 'DC'
    await updateDoc(userRef, {
      address: addressToChange,
    });
    setUserData({ ...userData, address: addressToChange });
    toggleAddressChange();
  };

  // payment
  const stripePromise = loadStripe(process.env.REACT_APP_PUB_KEY);

  const [clientSecretKey, setClientSecretKey] = useState(null);

  const [processingPayment, setProcessingPayment] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);

  useEffect(() => {
    if (payableAmount > 0) {
      handlePayment();
    }
  }, [payableAmount]);

  useEffect(() => {
    if (paymentDetails) {
      if (paymentDetails.success) {
        placeFinalOrder();
      } else {
        handleOpenPaymentResultModal();
      }
    }
  }, [paymentDetails]);

  const handlePayment = () => {
    const cpiUrl =
      "https://us-central1-homeguru-2e379.cloudfunctions.net/create_payment_intent";
    const amount = payableAmount * 100;
    const currency = "aed";
    const finalUrl = `${cpiUrl}?amount=${amount}&currency=${currency}`;
    axios
      .post(
        finalUrl,
        {},
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
          },
        }
      )
      .then((res) => {
        console.log("PAYMENT INTENT RES:", res);
        if (res.status === 200) {
          if (res.data && res.data.paymentIntent) {
            setClientSecretKey(res.data.paymentIntent);
          } else {
            setClientSecretKey(null);
          }
        }
      })
      .catch((err) => {
        console.log("PAYMENT INTENT ERR:", { ...err });
      });
  };

  useEffect(() => {
    const mAmount =
      appliedCoupon && appliedCoupon.status
        ? totalPrice + totalVat + finalTipAmount - appliedCoupon.benefit
        : totalPrice + totalVat + finalTipAmount;
    setPayableAmount(mAmount);
  }, [totalVat, totalPrice, finalTipAmount, appliedCoupon]);

  return (
    <div>
      {/* Place Booking Modal */}
      <Modal
        show={subTypesModal}
        onHide={handleCloseSubTypesModal}
        size="lg"
        className="place_booking_popup"
        id="exampleModa2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        centered
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="place_product_main">
                <div className="row">
                  <div className="col-lg-6 place_left_main">
                    <div className="row">
                      <div
                        className="row"
                        style={{
                          maxHeight: "400px",
                          overflowY: "auto",
                          width: "100%",
                        }}
                      >
                        {!loadingCart ? (
                          userCartItems.length ? (
                            userCartItems.map((mCartItem, index) => (
                              <div className="col-12" key={index}>
                                <div className="booking_product_inr">
                                  <div className="row align-items-center">
                                    <div className="col-sm-6 pr-sm-0">
                                      <img
                                        className="img-fluid"
                                        src={mCartItem.image || placeOr}
                                        alt="cart-item-img"
                                      />
                                    </div>
                                    <div className="col-sm-6">
                                      <h4>{mCartItem.name}</h4>

                                      <div className="remove_add_btn d-flex align-items-center justify-content-between">
                                        <h5>{`$ ${mCartItem.price}`}</h5>
                                        <button
                                          className="dlt_btn btn"
                                          onClick={() =>
                                            deleteCartItem(mCartItem)
                                          }
                                        >
                                          <i
                                            className="fa fa-trash"
                                            aria-hidden="true"
                                          ></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))
                          ) : (
                            <span className="p-4">No Cart Items Found!</span>
                          )
                        ) : (
                          <div
                            className="row"
                            style={{
                              width: "100%",
                              justifyContent: "center",
                              margin: "1em 0px",
                            }}
                          >
                            <div className="spinner-border"></div>
                          </div>
                        )}
                      </div>
                      <div className="col-12 d-flex justify-content-center">
                        <button
                          style={{ backgroundColor: "#c9002b", border: "none" }}
                          type="button"
                          className="btn btn-primary m-2"
                          onClick={() => {
                            handleCloseSubTypesModal();
                            history.push("/services");
                          }}
                        >
                          Add more services!
                        </button>
                      </div>
                      <div className="col-12 add_tips_prsnl">
                        <div className="booking_product_inr">
                          <h3>Add a Tip for professional</h3>
                          <ul>
                            <li
                              style={{
                                backgroundColor:
                                  tipAmount === 10 ? "#c9002b" : "",
                                color: tipAmount === 10 ? "#fff" : "",
                              }}
                              onClick={() => setTipAmount(10)}
                            >
                              <h4>10</h4>
                            </li>
                            <li
                              style={{
                                backgroundColor:
                                  tipAmount === 20 ? "#c9002b" : "",
                                color: tipAmount === 20 ? "#fff" : "",
                              }}
                              onClick={() => setTipAmount(20)}
                            >
                              <h4>20</h4>
                            </li>
                            <li
                              style={{
                                backgroundColor:
                                  tipAmount === 50 ? "#c9002b" : "",
                                color: tipAmount === 50 ? "#fff" : "",
                              }}
                              onClick={() => setTipAmount(50)}
                            >
                              <h4>50</h4>
                            </li>
                            <li
                              style={{
                                backgroundColor:
                                  tipAmount === 100 ? "#c9002b" : "",
                                color: tipAmount === 100 ? "#fff" : "",
                              }}
                              onClick={() => setTipAmount(100)}
                            >
                              <h4>100</h4>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 place_right_main">
                    <div className="row">
                      <div className="col-12 add_tips_prsnl">
                        <div className="booking_product_inr">
                          <h3>Subscribe to a Plan and save</h3>
                          <ul
                            style={{
                              overflowX: "auto",
                            }}
                          >
                            {subscriptions.length ? (
                              subscriptions.map((mSubscription, index) => (
                                <li key={index}>
                                  <h4 className="d-flex justify-content-between align-items-center">
                                    {mSubscription.no_of_services
                                      ? mSubscription.no_of_services
                                      : 0}
                                    <Link to="/subscription">
                                      <i
                                        className="fa fa-plus-circle"
                                        aria-hidden="true"
                                      ></i>
                                    </Link>
                                  </h4>
                                  <p>Services</p>
                                  <h5>
                                    {mSubscription.name
                                      ? mSubscription.name
                                      : ""}
                                  </h5>
                                </li>
                              ))
                            ) : (
                              <span className="p-2">
                                No Subscriptions found!
                              </span>
                            )}
                          </ul>
                        </div>
                      </div>
                      {/* if nonSubServices array is empty then show bill details */}
                      {userCartItems &&
                      userCartItems.length &&
                      nonSubServices.length ? (
                        <>
                          <div className="col-12 add_coupons">
                            <div className="booking_product_inr">
                              {/* <button className="btn">ADD COUPONS <i className="fa fa-chevron-right" aria-hidden="true"></i></button> */}
                              {appliedCoupon &&
                              appliedCoupon.status &&
                              appliedCoupon.coupon ? (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{ color: "green" }}
                                >
                                  {appliedCoupon.coupon.code}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  // data-toggle="modal"
                                  // data-target="#exampleModa4"
                                  onClick={handleOpenCouponModal}
                                >
                                  ADD COUPONS
                                </button>
                              )}
                            </div>
                          </div>
                          <div className="col-12 bill_details">
                            <div className="booking_product_inr">
                              <h2 className="d-flex justify-content-between align-items-center">
                                Bill Details <span>Add tip</span>
                              </h2>
                              <h5 className="d-flex justify-content-between align-items-center">
                                Item Total <span>$ {totalPrice}</span>
                              </h5>
                              <h5 className="d-flex justify-content-between align-items-center">
                                Tip <span>$ {finalTipAmount}</span>
                              </h5>
                              {appliedCoupon && appliedCoupon.status ? (
                                <h5
                                  style={{ color: "green" }}
                                  className="d-flex justify-content-between align-items-center"
                                >
                                  Coupon Discount{" "}
                                  <span>- $ {appliedCoupon.benefit}</span>
                                </h5>
                              ) : (
                                ""
                              )}
                              <h6 className="d-flex justify-content-between align-items-center">
                                Tax Charges <span>$ {totalVat}</span>
                              </h6>
                              <h4 className="d-flex justify-content-between align-items-center">
                                You pay <span>$ {payableAmount}</span>
                              </h4>
                            </div>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <button
                      type="button"
                      className="btn btn-primary place_btnn"
                      onClick={() => {
                        handleOpenDateTimeModal();
                        handleCloseSubTypesModal();
                      }}
                      disabled={!userCartItems.length}
                      // data-toggle="modal"
                      // data-target="#exampleModa7"
                    >
                      Place Booking
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* END BOOKING MODAL */}

      {/* SUBSCRIPTION STATUS MODAL */}
      <Modal
        show={subStatusModal}
        onHide={handleCloseSubStatusModal}
        size="lg"
        className="place_booking_popup"
        id="exampleModa2"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        centered
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="apply_coupons_main">
                <button className="btn ">
                  <i
                    onClick={handleCloseSubStatusModal}
                    className="fa fa-arrow-left pr-2"
                    aria-hidden="true"
                  ></i>
                  <span>Missing Subscriptions</span>
                </button>
                <p>You do not have suscriptions for following Services:</p>
                <ul>
                  {nonSubServices.length
                    ? nonSubServices.map((mService) => (
                        <li key={mService.sub_type_id}>{mService.name}</li>
                      ))
                    : ""}
                </ul>
                <div
                  style={{ width: "100%" }}
                  className="d-flex justify-content-center"
                >
                  <Link to="/subscription">
                    <button
                      style={{ backgroundColor: "#c9002b", border: "none" }}
                      type="button"
                      className="btn btn-primary m-2"
                    >
                      Buy a Subscription
                    </button>
                  </Link>
                  {/* TODO: change phone number */}
                  <a href="tel:+911122334455">
                    <button
                      style={{ backgroundColor: "#c9002b", border: "none" }}
                      type="button"
                      className="btn btn-primary m-2"
                    >
                      Call us!
                    </button>
                  </a>
                  <button
                    type="button"
                    className="btn btn-secondary m-2"
                    onClick={handleCloseSubStatusModal}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* END SUBSCRIPTION STATUS MODAL */}

      {/* APPLY COUPOBNS */}
      <Modal
        show={couponModal}
        onHide={handleCloseCouponModal}
        className="modal fade apply_coupons_model"
        id="exampleModa4"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="apply_coupons_main">
                <button className="btn header_back_modal">
                  <i
                    onClick={handleCloseCouponModal}
                    className="fa fa-arrow-left"
                    aria-hidden="true"
                  ></i>{" "}
                  Apply coupon
                </button>
                <div className="enter_cooupon_code">
                  <input
                    type="text"
                    name=""
                    id=""
                    placeholder="Enter Coupon Code"
                  />
                  <button
                    type="button"
                    className="btn btn-info"
                    // data-toggle="modal"
                    // data-target="#exampleModa5"
                    // data-dismiss="modal"
                    onClick={() => {
                      // TODO: add custom coupon code
                    }}
                  >
                    Apply
                  </button>
                </div>
                <h3>Applicable coupons</h3>
                {couponsList && couponsList.length
                  ? couponsList.map((mCoupon) => (
                      <div key={mCoupon.id} className="applicable_coupons">
                        <h5>{mCoupon.code}</h5>
                        <p className="d-flex justify-content-between align-items-center">
                          {mCoupon.description}
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => checkCouponValidity(mCoupon)}
                            disabled={new Date() > new Date(mCoupon.validity)}
                            // data-toggle="modal"
                            // data-target="#exampleModa5"
                          >
                            {new Date() > new Date(mCoupon.validity)
                              ? "Expired"
                              : "Apply"}
                          </button>
                        </p>
                        <h4>Details</h4>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* END APPLY COUPOBNS */}

      {/* CONGRATS */}
      <Modal
        show={congratsModal}
        onHide={handleCloseCongratsModal}
        className="congrats_model you_save_aed_10"
        id="exampleModa5"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        centered
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              {congratsMessage.status ? (
                <img className="img-fluid" src={noto} alt="dd" />
              ) : (
                ""
              )}
              <h4>{congratsMessage.message}</h4>
            </div>
            <button
              type="button"
              className="btn btn-info"
              // data-toggle="modal"
              // data-target="#exampleModa3"
              // data-dismiss="modal"
            >
              <i
                class="fa fa-times"
                aria-hidden="true"
                onClick={() => {
                  setCongratsMessage({ status: false, message: "" });
                  handleCloseCongratsModal();
                }}
              ></i>
            </button>
          </div>
        </div>
      </Modal>
      {/* CONGRATS */}

      {/* DATE TIME MODAL */}
      <Modal
        show={dateTimeModal}
        onHide={() => {
          handleCloseDateTimeModal();
          handleOpenSubTypesModal();
        }}
        className="date_and_time"
        id="exampleModa7"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        centered
        size="lg"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="apply_coupons_main">
                <button className="btn header_back_modal">
                  <i
                    onClick={() => {
                      handleCloseDateTimeModal();
                      handleOpenSubTypesModal();
                    }}
                    className="fa fa-arrow-left"
                    aria-hidden="true"
                  ></i>{" "}
                  Date and time
                </button>
              </div>
              <div className="date_and_time_body">
                <div className="row row1">
                  <label>Name</label>{" "}
                  <span>{userData && userData.name ? userData.name : ""}</span>
                </div>
                <div className="row row1">
                  <label>Contact number</label>
                  <span>
                    {userData && userData.phone ? userData.phone : ""}
                  </span>
                </div>
                {console.log("ADDRESS: ", userData)}
                {changeAddressActive ? (
                  <>
                    <div className="row row1">
                      <label>Address</label>
                      <div className="payment_cod_input input_search_icon">
                        <input
                          type="text"
                          name="newAddress"
                          value={addressToChange}
                          onChange={(e) => setAddressToChange(e.target.value)}
                        />
                        <div>
                          <button
                            className="change_btn"
                            onClick={updateTheAddress}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row row1">
                      <label>Address</label>
                      <span>
                        {userData
                          ? userData.address
                            ? userData.address
                            : "No Address found! Please change!"
                          : "No Address found! Please change!"}
                      </span>
                    </div>
                    <div className="row row1">
                      <label></label>
                      <button
                        className="change_btn"
                        onClick={toggleAddressChange}
                      >
                        Change
                      </button>
                    </div>
                  </>
                )}

                <p>When do you need the services?</p>
                <div className="row row2">
                  {/* <div className="col-6">
                    <label>Date</label>
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => {
                        console.log(
                          "DATE:",
                          date.getDate(),
                          date.getMonth(),
                          date.getFullYear()
                        );
                        setStartDate(date);
                      }}
                    />
                  </div> */}
                  <div className="col-6">
                    <label>Date & Time</label>
                    <Datetime
                      initialValue={dateTime}
                      onChange={(mDateTime) => {
                        console.log("DATETIME:", mDateTime.toDate().getTime());
                        setDateTime(mDateTime.toDate().getTime());
                      }}
                    />
                  </div>
                </div>
                <p>Please discribe the job in as much detail as possible</p>
                <div className="row row3">
                  <textarea
                    className="w-100"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    id=""
                    name=""
                    rows=""
                    cols=""
                  ></textarea>
                </div>
                <div className="row justify-content-end">
                  <button
                    type="button"
                    className="btn btn-primary next_btnn"
                    onClick={() => {
                      // confirm first, then payment
                      handleOpenLocationModal();
                      handleCloseDateTimeModal();
                    }}
                    // data-toggle="modal"
                    // data-target="#exampleModa9"
                  >
                    NEXT
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* DATE TIME MODAL */}

      {/* CONFIRM  location Modal */}

      <Modal
        show={locationModal}
        onHide={() => {
          handleCloseLocationModal();
          handleOpenDateTimeModal();
        }}
        className="fade confirm_location_modal"
        id="exampleModa10"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="apply_coupons_main">
                <button
                  className="btn header_back_modal"
                  onClick={() => {
                    handleCloseLocationModal();
                    handleOpenDateTimeModal();
                  }}
                >
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                  Confirmation
                </button>
              </div>
              <div className="date_and_time_body">
                <div className="row row1">
                  <label>Name</label>{" "}
                  <span>{userData && userData.name ? userData.name : ""}</span>
                </div>
                <div className="row row1">
                  <label>Contact number</label>
                  <span>
                    {userData && userData.phone ? userData.phone : ""}
                  </span>
                </div>
                {changeAddressActive ? (
                  <>
                    <div className="row row1">
                      <label>Address</label>
                      <div className="payment_cod_input input_search_icon">
                        <input
                          type="text"
                          name="newAddress"
                          value={addressToChange}
                          onChange={(e) => setAddressToChange(e.target.value)}
                        />
                        <div>
                          <button
                            className="change_btn"
                            onClick={updateTheAddress}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="row row1">
                      <label>Address</label>
                      <span>
                        {userData
                          ? userData.address
                            ? userData.address
                            : "No Address found! Please change!"
                          : "No Address found! Please change!"}
                      </span>
                    </div>
                    <button
                      className="change_btn"
                      onClick={toggleAddressChange}
                    >
                      Change
                    </button>
                  </>
                )}
                <div className="google_maps">
                  <iframe
                    title="lazy"
                    src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d15258072.40570261!2d82.75252935!3d20.98801345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1632411515739!5m2!1sen!2sin"
                    allowfullscreen=""
                    loading="lazy"
                  ></iframe>
                </div>
                {/* <div className="row row1">
                  <label>Payment method</label>
                  <span>{nonSubServices.length ? paymentMode : "N/A"}</span>
                </div> */}
                <div className="row row1">
                  <label>Promo Code</label>
                  <span>
                    {appliedCoupon && appliedCoupon.status
                      ? appliedCoupon.code
                      : "N/A"}
                  </span>
                </div>
                <div className="row row1">
                  <label>Payable Amount</label>
                  <span>
                    {console.log("NONSUBSER:", nonSubServices)}
                    {nonSubServices.length > 0 ? (
                      <>
                        {/* some non-subscribed services, payment is required */}
                        <span>$ {payableAmount}</span>
                      </>
                    ) : (
                      <>
                        {/* all subscribed services */}
                        <span>Subscription is getting availed</span>
                      </>
                    )}
                  </span>
                </div>
                <div className="row justify-content-center">
                  {totalPrice > 0 ? (
                    <button
                      type="button"
                      className="btn btn-primary next_btnn"
                      onClick={() => {
                        handleOpenPaymentModal();
                        handleCloseLocationModal();
                      }}
                    >
                      PAY
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn-primary next_btnn"
                      onClick={placeFinalOrder}
                    >
                      BOOK
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* map location Modal */}

      {/* PAYMENT MODAL */}
      <Modal
        show={paymentModal}
        onHide={() => {
          handleClosePaymentModal();
          handleOpenLocationModal();
        }}
        className="fade payment_modal_design"
        id="exampleModa9"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="apply_coupons_main">
                <button
                  className="btn header_back_modal"
                  onClick={() => {
                    handleClosePaymentModal();
                    handleOpenLocationModal();
                  }}
                >
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>{" "}
                  Payment Details
                </button>
              </div>

              <div className="payment_modal_design_body">
                <h3>How would you like to pay?</h3>
                <div className="payment_cod">
                  <span
                    onClick={() => setPaymentMode("COD")}
                    style={{
                      backgroundColor: paymentMode === "COD" ? "#c9002b" : "",
                      color: paymentMode === "COD" ? "#fff" : "",
                      padding: "0.4em",
                      borderRadius: "0.5rem",
                      cursor: "pointer",
                    }}
                  >
                    COD
                  </span>

                  <span style={{ padding: "0.4em" }}>
                    <i className="fa fa-money" aria-hidden="true"></i>
                  </span>
                  <span
                    onClick={() => setPaymentMode("ONLINE")}
                    style={{
                      backgroundColor:
                        paymentMode === "ONLINE" ? "#c9002b" : "",
                      color: paymentMode === "ONLINE" ? "#fff" : "",
                      padding: "0.4em",
                      borderRadius: "0.5rem",
                      cursor: "pointer",
                    }}
                  >
                    Online
                  </span>
                </div>
                {paymentMode === "ONLINE" && clientSecretKey ? (
                  <Elements
                    stripe={stripePromise}
                    options={{ clientSecret: clientSecretKey }}
                  >
                    <PaymentGateway
                      processingPayment={processingPayment}
                      setProcessingPayment={setProcessingPayment}
                      paymentDetails={paymentDetails}
                      setPaymentDetails={setPaymentDetails}
                    />
                  </Elements>
                ) : (
                  ""
                )}
                <div className="row justify-content-end m-0">
                  {paymentMode === "COD" ? (
                    <button
                      type="button"
                      className="btn btn-primary next_btnn"
                      onClick={() => {
                        console.log("CLIECKKEDD");
                        placeFinalOrder();
                      }}
                      // data-toggle="modal"
                      // data-target="#exampleModa10"
                    >
                      Continue
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* PAYMENT MODAL */}

      {/* THANK YOU MODAL */}
      <Modal
        show={thankYouModal}
        onHide={handleCloseThankYouModal}
        className="fade congrats_model"
        id="exampleModa13"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <img className="img-fluid" src={noto} alt="" />
              <p>Thank you, Book again!</p>
              <button className="track_btn">Track your Professional</button>
            </div>
          </div>
        </div>
      </Modal>
      {/* THANK YOU MODAL */}

      {/*  */}
      <Modal
        show={paymentResultModal}
        onHide={handleClosePaymentResultModal}
        className="modal gold_membership"
        id="BuySubModal"
        centered
        tabIndex="-1"
        aria-labelledby="BuySubModal"
        aria-hidden="true"
      >
        <div className="modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                }}
              >
                {paymentDetails ? (
                  paymentDetails.success ? (
                    <div>
                      Paid AED {paymentDetails.success.amount / 100}{" "}
                      Successfully!
                      {console.log("RESULT:", paymentDetails.success)}
                    </div>
                  ) : (
                    <div>
                      Something went wrong! Try Again!
                      {console.log("RESULT:", paymentDetails.error)}
                    </div>
                  )
                ) : (
                  ""
                )}

                <button
                  className="btn btn-secondary btn-small center align-center mt-4"
                  onClick={handleClosePaymentResultModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/*  */}
    </div>
  );
};

export default CartCheckout;
